import { lazy } from 'react';
import { RecordVoiceOver } from '@mui/icons-material';
import type { ToolDefinition } from '../registry';

export const constatAudioTool: ToolDefinition = {
  id: 'constat-audio',
  name: 'Constat audio',
  icon: RecordVoiceOver,
  basePath: '/constat-audio',
  routes: [
    { path: '/constat-audio', component: lazy(() => import('./pages/ConstatAudioListPage')) },
    { path: '/constat-audio/nouveau', component: lazy(() => import('./pages/NewConstatAudioPage')) },
    { path: '/constat-audio/:id', component: lazy(() => import('./pages/ConstatAudioDetailPage')) },
  ],
};
